import * as Collapsible from '@radix-ui/react-collapsible'
import React, { useCallback, useState } from 'react'

import { css } from 'design'
import { buttonStyles } from 'primitives/button'
import { cn } from 'util/cn'

export const TimelineGroup = ({ children, ...props }) => {
  const [isCollapseOpen, setCollapseOpen] = useState(false)

  const onOpenChange = useCallback(() => {
    setCollapseOpen((s) => !s)
  }, [])

  const collapseHeaderText = isCollapseOpen
    ? 'Show Less'
    : `Show ${children.length - 1}+`

  const topChildren = children.slice(0, 1)
  const remainingChildren = children.slice(1, children.length)

  return (
    <div className={groupStyles()} role={'listitem'} tabIndex={-1} {...props}>
      <ul className={groupStyles()}>{topChildren}</ul>
      <Collapsible.Root onOpenChange={onOpenChange}>
        <Collapsible.Button className={cn(groupStyles(), dividerStyles())}>
          <hr />
          <div
            className={cn(buttonStyles({ shape: 'pill' }), pillButtonStyles())}
          >
            {collapseHeaderText}
          </div>
          <hr />
        </Collapsible.Button>
        <Collapsible.Content as="ul" className={groupStyles()}>
          {remainingChildren}
        </Collapsible.Content>
      </Collapsible.Root>
    </div>
  )
}

const groupStyles = css({
  width: '100%',
})

const dividerStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  border: 0,
  background: 'transparent',
  padding: '0 20px',
  outline: 0,
  '> hr': {
    display: 'flex',
    flex: '1 1 0',
  },
  '> * + *': {
    marginLeft: '$2',
  },
})

const pillButtonStyles = css({ whiteSpace: 'pre' })
